import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { Task, TaskAssignee, TaskLabel } from "../taskbook.types";
import { MatButtonModule } from "@angular/material/button";
import { MatMenuModule } from "@angular/material/menu";
import { TranslateModule } from "@ngx-translate/core";
import { CommonModule } from "@angular/common";
import { HeaderService } from "../../header/header.service";
import {
    KeepWithLabelPopoverSelectorComponent
} from "../task-label/keep-with-label-popover-selector/keep-with-label-popover-selector.component";
import { KeepTriageActionComponent } from "./keep-triage-action/keep-triage-action.component";

@Component({
    selector: 'taskbook-triage-actions',
    templateUrl: './taskbook-triage-actions.component.html',
    styleUrls: ['./taskbook-triage-actions.component.scss', '../task/task.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
    CommonModule,
    TranslateModule,
    MatButtonModule,
    MatMenuModule,
    KeepTriageActionComponent
]
})
export class TaskbookTriageActionsComponent {

    @Input() context: 'taskbook' | 'task-success-dialog';
    @Input() task: Task;
    @Input() managers: TaskAssignee[];

    @Output() onAction = new EventEmitter<{ task: Task, actionId: string }>()

    constructor(
        private headerService: HeaderService,
    ){}

    skipAction(){
        this.headerService.decrementTriageCounter();
        this.onAction.emit({ task: this.task, actionId: 'archive' })
    }

    keepAction({assignees: assignees, labels: labels}: {assignees: TaskAssignee[], labels: TaskLabel[]}) {
        this.task.labels = labels;
        this.task.assignees = assignees;
        this.onAction.emit({ task: this.task, actionId: 'keep' })
    }
}
